// extracted by mini-css-extract-plugin
export default {"container":"Quiz_container__z1sBB","containerQuiz":"Quiz_containerQuiz__ibua5"};